import FantAnimals from "../assets/projects/fantastic_animals.png";
import WebChat from "../assets/projects/web_chat.png";
import PortalIg from "../assets/projects/portal_ig.png";
import Wallet from "../assets/projects/wallet.png";
import Nossostand from "../assets/projects/nossostand.png";
import Wine from "../assets/projects/wine.png";

export const data = [
  {
    id: 1,
    name: "Projeto Web-chat em ReactJs e Socket.io",
    image: WebChat,
    github: "https://github.com/alansgoncalves/web-chat",
    live: "https://rock-web-chat.herokuapp.com/",
  },
  {
    id: 2,
    name: "Website em JS e CSS",
    image: FantAnimals,
    github: "https://github.com/alansgoncalves/fantastic_animals",
    live: "https://fantastic-animals-roan.vercel.app/",
  },
  {
    id: 3,
    name: "Carteira conversora de moedas em Redux",
    image: Wallet,
    github: "https://github.com/alansgoncalves/wallet_conversor",
    live: "https://alansgoncalves.github.io/wallet_conversor/",
  },
  {
    id: 4,
    name: "Projeto em RectJS e NextJs",
    image: Wine,
    github: "https://github.com/alansgoncalves/wine-app",
    live: "https://wine-efn9joy0l-alansgoncalves.vercel.app/",
  },
  {
    id: 5,
    name: "Nossostand - Website para cadastro de eventos em ReactJs",
    image: Nossostand,
    github: "https://github.com/alansgoncalves/nossostand",
    live: "https://nossostand-jrp4cuwb3-alansgoncalves.vercel.app/",
  },
  {
    id: 6,
    name: "Portal iG - Login Unificado em ReactJs e AWS",
    image: PortalIg,
    live: "https://ig-uni-login-sdk.vercel.app/",
  },
];
